import { createSelector } from 'reselect';

import { formatSelectedMonth } from 'app/dealer/shared/utils/pure-functions/dates';

import { getListingsBenchmarkReducer } from '../selectors';

/**
 * @description all errors
 */
export const selectAllListingsBenchmarkErrors = createSelector(
  [getListingsBenchmarkReducer],
  ({ errors }) => errors,
);

/**
 * @description
 * error state for entire feature
 */

export const getFullErrorState = (state, action) => ({
  ...state,
  dataRequestLoading: false,
  errors: [
    ...state.errors,
    { [action.type]: action.error.message || action.error },
  ],
});

export const selectListingsBenchmarkFirstDataRequestCompleted = createSelector(
  [getListingsBenchmarkReducer],
  ({ firstDataRequestCompleted }) => firstDataRequestCompleted,
);

export const selectListingsBenchmarkDataRequestLoading = createSelector(
  [getListingsBenchmarkReducer],
  ({ dataRequestLoading }) => dataRequestLoading,
);

export const selectListingsBenchmarkDataRequestComplete = createSelector(
  [getListingsBenchmarkReducer],
  ({ dataRequestCompleted }) => dataRequestCompleted,
);

/**
 * @description
 * task cancellation
 */
export const selectListingsBenchmarkDataRequestCancelled = createSelector(
  [getListingsBenchmarkReducer],
  ({ dataRequestCancelled }) => dataRequestCancelled,
);

// #region date filters
export const selectListingsBenchmarkSelectedMonth = createSelector(
  [getListingsBenchmarkReducer],
  ({ selectedMonth }) => selectedMonth,
);

export const selectListingsBenchmarkSelectedYear = createSelector(
  [getListingsBenchmarkReducer],
  ({ selectedYear }) => selectedYear,
);

export const selectListingsBenchmarkApiDate = createSelector(
  [selectListingsBenchmarkSelectedMonth, selectListingsBenchmarkSelectedYear],
  (month, year) => `${year}-${formatSelectedMonth(month)}`,
);

export const selectListingsBenchmarkSelectedDate = createSelector(
  [getListingsBenchmarkReducer],
  ({ selectedDate }) => new Date(selectedDate),
);

export const selectIsCurrentDate = createSelector(
  [selectListingsBenchmarkSelectedMonth, selectListingsBenchmarkSelectedYear],
  (month, year) =>
    month - 1 === new Date().getMonth() && year === new Date().getFullYear(),
);
// #endregion date filters
